import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
import { reactive, computed } from 'vue';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { storeToRefs } from 'pinia';
export default {
  __name: 'RemoveLineItemModal',
  props: {
    typeLabel: String,
    adjustOption: {
      type: Boolean,
      default: false
    }
  },
  emits: ['cancel', 'confirm'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      selectedLineItem
    } = storeToRefs(useInvoiceEditorStore());
    const props = __props;
    const emit = __emit;
    const dynamicTypeLabel = computed(() => {
      return selectedLineItem.value?.expenses?.length > 0 ? 'These Expenses' : props.typeLabel;
    });
    const state = reactive({
      selectedAction: null,
      radioListOptions: [{
        header: `Save ${props.typeLabel} for Later`,
        content: `${props.typeLabel} will be removed from this invoice but can still be added to a new invoice later`,
        value: 'savedForLater'
      }]
    });
    if (props.adjustOption) {
      state.radioListOptions.push({
        header: `Adjust ${props.typeLabel} to Zero`,
        content: `${props.typeLabel} will be removed from invoicing and appear in reports as a write-down`,
        value: 'writeDown'
      });
    }
    state.radioListOptions.push({
      header: `Delete ${props.typeLabel} permanently`,
      content: `${props.typeLabel} will be permanently deleted as if it never existed`,
      value: 'deleted'
    });
    const confirm = () => {
      emit('confirm', {
        action: state.selectedAction
      });
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_radio = _resolveComponent("v-radio");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_radio_group = _resolveComponent("v-radio-group");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      return _openBlock(), _createBlock(_component_v_card, null, {
        prepend: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "headline"
        }, {
          default: _withCtx(() => [_createTextVNode("Remove " + _toDisplayString(dynamicTypeLabel.value), 1)]),
          _: 1
        })]),
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('cancel'))
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createElementVNode("p", null, " Decide what you'd like to do with " + _toDisplayString(dynamicTypeLabel.value.toLowerCase()) + ". These changes won't be applied until you save the invoice. ", 1), _createElementVNode("div", null, [_createVNode(_component_v_row, {
            class: "mx-2"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.radioListOptions, option => {
              return _openBlock(), _createBlock(_component_v_radio_group, {
                modelValue: state.selectedAction,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.selectedAction = $event),
                key: option.value,
                column: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_v_col, null, {
                  default: _withCtx(() => [_createVNode(_component_v_card, {
                    outlined: "",
                    tile: "",
                    onClick: $event => state.selectedAction = option.value,
                    color: state.selectedAction === option.value ? 'primary' : ''
                  }, {
                    default: _withCtx(() => [_createVNode(_component_v_radio, {
                      label: option.header,
                      value: option.value,
                      class: "p-0 text-base font-medium hidden-radio"
                    }, null, 8, ["label", "value"]), _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [_createElementVNode("p", null, _toDisplayString(option.content), 1)]),
                      _: 2
                    }, 1024)]),
                    _: 2
                  }, 1032, ["onClick", "color"])]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["modelValue"]);
            }), 128))]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_v_card_actions, {
          class: "mx-2"
        }, {
          default: _withCtx(() => [_createVNode(LlSecondaryButton, {
            color: "primary",
            variant: "flat",
            "data-cy": "confirm-remove",
            onBtnClick: _cache[2] || (_cache[2] = $event => confirm()),
            disabled: !state.selectedAction
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" Apply ", -1)]))]),
            _: 1
          }, 8, ["disabled"]), _createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
            class: "mr-2",
            onBtnClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('cancel'))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Cancel ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};